import { render, staticRenderFns } from "./QIUBO_SCM_TEST2.vue?vue&type=template&id=015990ae&scoped=true"
import script from "./QIUBO_SCM_TEST2.vue?vue&type=script&lang=js"
export * from "./QIUBO_SCM_TEST2.vue?vue&type=script&lang=js"
import style0 from "./QIUBO_SCM_TEST2.vue?vue&type=style&index=0&id=015990ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015990ae",
  null
  
)

export default component.exports